module.exports = __webpack_public_path__ + "img/DSC_2940.9166313e.png";